import React from 'react'
import {networks} from '../../lib/stellar'
import CustomNetworkButton from '../shared/CustomNetworkButton'

const NetworkButton = ({networkType, selectedNetworkType, switchNetworkType}) =>
  <button
    className={networkType === selectedNetworkType ? 'is-active' : 'is-inactive'}
    onClick={e => switchNetworkType(networkType)}
  >
    {networkType.toUpperCase()}
  </button>

const NetworkSelector = props =>
  <div className="Network-Selector">
    {[networks.public].map(networkType =>
      <NetworkButton
        key={networkType}
        hide={networks[networkType].hide}
        networkType={networkType}
        selectedNetworkType={props.networkType}
        switchNetworkType={props.switchNetworkType}
      />
    )}
  </div>

export default NetworkSelector



// WEBPACK FOOTER //
// ./src/components/layout/NetworkSelector.js